<template>
  <b-container fluid class="recruiter create-job-offer v2_color_black h-100">
    <b-row>
      <b-col cols="12" class="d-flex justify-content-center align-items-center">
        <template v-if="this.isShowStep==1">
            <div class="text-center mt-20">
              <template v-if="this.jobInfoText"> <b class="v3_color_teal">Complete the fields below to add the messages and context you want your candidates to receive.</b>  </template>
              <template v-else> <b class="v3_color_teal">Select from the “Job Criteria” menu if you want to refine or add to the specific terms of your job opportunity.</b>  </template>
            </div>
        </template>
        <template v-if="this.isShowStep==3">
            <div class="text-center mt-20">
                <b class="v3_color_teal">Take a minute to review your job opportunity - click ‘Back’ to adjust anything you like and click ‘Next’ when ready.</b>
            </div>
        </template>
        <template v-if="this.isShowStep == 5">
          <div class="text-center mt-20">
              <p class="v3_color_teal v2_font_size_22 font_weight_semibold">That’s it! </p>
              <b class="v3_color_teal">We’ve connected your job opportunity to the physician candidates that have expressed an interest in it. </b>
          </div>
        </template>
        <template v-if="this.isShowStep == 4">
          <div class="text-center mt-20">
              <b class="v3_color_teal">You’re set to go! Complete the payment fields below and we’ll immediately connect your opportunity to all interested candidates.</b>
          </div>
        </template>
      </b-col>
      <template v-if="this.isShowStep == 2">
        <!-- <b-col cols="12" class="d-flex justify-content-center align-items-center">
          <b class="v3_color_teal mt-4">Register Your Job Opportunity</b>
        </b-col> -->
      </template>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card border-variant="light" class="mt-2 p-2 v2_bg_white h-100">
          <div v-if="this.existMissingFields">
            <b-alert show variant="warning">
              Job Information fields are empty and should be filled with values.
            </b-alert>
          </div>
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <div class="text-center">
                  <b class="v3_color_teal">Step 1. Select Job Criteria</b>
              </div>
            </b-col>
            <b-col sm="12" md="8" lg="6">
              <div class="text-center">
                  <b class="v3_color_teal">Step 2. Define Job Criteria</b>
              </div>
            </b-col>
            <b-col sm="12" md="12" lg="3">
              <div class="text-center">
                  <b class="v3_color_teal">Step 3. Evaluate Results</b>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <div class="border_1 h-100 w-100 p-3">
                <v-wait :visible="loadingDetail" :for="$options.name">
                  <template slot="waiting">
                    <HalfCircleSpinner />
                    <div class="spinner-message my-3 text-center">
                      Loading data...
                    </div>
                  </template>
                  <v-wait :visible="loadingJobTerms" for="job-terms">
                    <template slot="waiting">
                      <HalfCircleSpinner />
                      <div class="spinner-message my-3 text-center">
                        Loading job terms...
                      </div>
                    </template>
                    <div class="text-center v2_font_size_22 v2_font_Montserrat">
                      Job Criteria
                    </div>
                    <div class="d-flex flex-column justify-content-stretch">
                      <template v-for="criteria in jobCriteria">
                        <b-button
                          v-if="criteria.talent_type=='SPECIALTY'"
                          :key="criteria.id"
                          variant="v2_white_primary_teal"
                          :class="[
                            'mb-2',
                            {
                              active:
                                selectedJobQuestion &&
                                selectedJobQuestion.id === criteria.id,
                            },
                          ]"
                          @click="selectedJobQuestion = criteria"
                          :disabled="isSpecialtyShow"
                        >
                          <span>
                            <i
                              v-if="showLockIcon(criteria) || isShowLock"
                              class="mdi mdi-18px mdi-lock"
                            />
                            {{ criteria.label }}
                          </span>
                        </b-button>
                      </template>
                      <template v-for="jobQuestion in jobQuestions">
                          <b-button
                            :key="jobQuestion.id"
                            :id="jobQuestion.id"
                            variant="v3_teal_outline"
                            :disabled_1="LocationDisabled || isShowStep != 1"
                            :disabled="jobQuestion.label == 'Location' ? LocationDisabled : (jobQuestion.label == 'Practice Ownership Type' ? practiceTypeFlag : (jobQuestion.label == 'Maximum Total Compensation') ? maxCompFlag : true)"
                            :class="[
                              'mb-2',
                              {
                                active:
                                  selectedJobQuestion &&
                                  selectedJobQuestion.id === jobQuestion.id,
                              },
                            ]"
                            @click="selectedJobQuestion = jobQuestion"
                          >
                            <span>
                              <i
                                v-if="showLockIconOnQuestion(jobQuestion) || isShowLock"
                                class="mdi mdi-18px mdi-lock"
                              />
                              {{ jobQuestion.label }}
                            </span>
                          </b-button>
                      </template>
                      <!-- <template v-for="otherCriteria in jobOtherCriteria">
                        <b-button
                          :key="otherCriteria.id"
                          variant="v3_teal_outline"
                          :disabled="isCriteriaButtonDisabled || isShowStep != 1"
                          :class="[
                            'mb-2',
                            {
                              active:
                                selectedJobQuestion &&
                                selectedJobQuestion.id === otherCriteria.id,
                            },
                          ]"
                          @click="selectedJobQuestion = otherCriteria"
                        >
                          {{ otherCriteria.label }}
                        </b-button>
                      </template> -->
                     <template v-for="jobTerm in jobTerms">
                        <b-button
                          :key="jobTerm.id"
                          variant="v3_teal_outline"
                          :disabled_1="isCriteriaButtonDisabled || isShowStep != 1"
                          :disabled="!isEnableOpportunityBtn"
                          :class="[
                            'mb-2',
                            {
                              active:
                                selectedJobQuestion &&
                                selectedJobQuestion.id === jobTerm.id,
                            },
                          ]"
                          @click="selectedJobQuestion = jobTerm"
                        >
                          <span>
                            <i
                              v-if="showLockIconOnTerm(jobTerm)"
                              class="mdi mdi-18px mdi-lock"
                            />
                            {{ jobTerm.label }}
                          </span>
                         
                        </b-button>
                      </template>
                      <!-- <template v-for="criteria in jobCriteria">
                        <b-button
                          v-if="criteria.talent_type=='JOB_INFORMATION'"
                          :key="criteria.id"
                          variant="v2_white_primary_teal"
                          :disabled="isCriteriaButtonDisabled"
                          :class="[
                            'mb-2',
                            {
                              active:
                                selectedJobQuestion &&
                                selectedJobQuestion.id === criteria.id,
                            },
                          ]"
                          @click="selectedJobQuestion = criteria"
                        >
                          <span>
                            <i
                              v-if="showLockIcon(criteria)"
                              class="mdi mdi-18px mdi-lock"
                            />
                            {{ criteria.label }}
                          </span>
                        </b-button>
                      </template> -->
                    </div>
                  </v-wait>
                </v-wait>
              </div>
            </b-col>
            <b-col sm="12" md="8" lg="6" class="position-relative">
              <div class="border_1 h-100 w-100 p-3" >
                <template v-if="selectedJobQuestion && this.isShowStep==1">
                  <div class="h-100 connect-opp-btn-main-div">
                  <job-offer-input
                    v-if="selectedJobQuestion && this.isShowStep==1"
                    ref="jobOfferInput"
                    :job-question="selectedJobQuestion"
                    :job-offer="jobOffer"
                    :loading="loadingDetail"
                    @save-details="updateJobOfferDetails"
                    @save-specialty="updateSpecialty"
                    @set-criteria-value="onSetJobQuestionValue"
                    @set-job-terms="onSetJobTerms"
                    @set-profile-job-terms="onSetProfileJobTerms"
                    @show-next-btn="showNextButton"
                    @updatePropValue="updateIsShowStep"
                    @isJobInfoActive="showJobInfo"
                    class="h-100"
                  />

                  <b-form-row v-if="!this.jobInfoText && isShowNextBtn" class="mt-5">
                      <b-col cols="12"  class="d-flex justify-content-center">
                        <b-button
                        variant="primary"
                        type="submit"
                        class="px-5 btn-disable-btn align-items-center margin-0-auto connect-opp-btn"
                        @click="goToJobInfo"
                        :disabled="!isEnableOpportunityBtn"
                        >
                        <span>Connect Your Job Opportunity</span>
                      </b-button>
                    </b-col>
                  </b-form-row>

                  </div>
                  <!-- <div class="d-flex align-items-center mt-4 w-100" v-if="!this.jobInfoText && isShowNextBtn">
                    <b-button @click="goToJobInfo" variant="primary" :disabled="!isEnableOpportunityBtn"  class="align-items-center margin-0-auto btn btn-disable-btn">
                      Connect Your Job Opportunity
                    </b-button>
                  </div> -->
                  

                  <!-- <b-form-row v-if="!isShowNextBtn">
                    <b-col cols="5" class="d-flex justify-content-right mt-3"></b-col>
                      <b-col cols="7"  class="d-flex justify-content-left mt-3">
                        <b-button
                        variant="primary"
                        type="submit"
                        class="px-5 btn-disable-btn position-bottom"
                        @click="handleButtonClick()"
                        :disabled="isDisabled"
                        >
                        <span>Next</span> <i class="mdi mdi-arrow-right-bold ml-1"></i>
                      </b-button>
                    </b-col>
                  </b-form-row> -->
                </template>
                <template v-else-if="this.isShowStep==2">
                  <recruiter-user-info
                    :loading="loadingDetail"   
                    :isShowStep="isShowStep"  
                    @updatePropValue="updateIsShowStep"             
                  />
                </template>
                <template v-else-if="this.isShowStep==3">
                 <review-job-offer
                    :loading="loadingDetail"   
                    :isShowStep="isShowStep"  
                    @updatePropValue="updateIsShowStep"             
                  />
                </template>
                <template v-else-if="this.isShowStep == 4">
                  <purchase-page
                    :loading="loadingDetail"   
                    :isShowStep="isShowStep"  
                    @updatePropValue="updateIsShowStep"  
                  />
                </template>
                <template v-else-if="this.isShowStep == 5">
                  <b-row class="center-align-box">
                    <b-col cols="6" class="text-center">
                      <b-button class="post_opportunity_btn" variant="v2_primary pt-5 pb-6" @click="saveJobOffer('dashboard')">
                        <p class="font_weight_semibold v2_font_size_20">Go To Dashboard</p>
                        <p>Monitor and Manage candidates for your Job Opportunity</p>
                      </b-button>
                    </b-col>

                    <b-col cols="6" class="text-center">
                      <b-button class="post_opportunity_btn" variant="v2_primary pt-5 pb-6" @click="saveJobOffer('inform')">
                        <p class="font_weight_semibold v2_font_size_20">Go to Inform</p>
                        <p>Assess specialty benchmarking data to refine your Job Opportunity</p>
                      </b-button>
                    </b-col>
                  </b-row>
                </template>
                <template v-else>
                  <b-row>
                    <b-col>
                      Select the criteria from the left menu to adjust.
                    </b-col>
                  </b-row>
                </template>
              </div>
            </b-col>
            <b-col sm="12" md="12" lg="3" class="mt-md-2 mt-lg-0">
              <div class="border_1 h-100 w-100 pt-1 pb-4 px-2">
                <b-row>
                  <b-col sm="12" md="6" lg="12">
                      <recruiter-ico-criteria-results
                        :criteria-items="jDatas"
                      />
                  </b-col>
                  <b-col sm="12" md="6" lg="12" class="mt-3 mt-md-0 mt-lg-3">
                    <recruiter-job-offers-matching>
                      <template slot="number">
                        {{ numberOfMatches }}
                      </template>
                    </recruiter-job-offers-matching>
                    <!-- <div class="mt-3 text-center">
                      <b-button
                        variant="v2_primary"
                        @click="onSave"
                        :disabled="
                          postItLaterLoading ||
                          postItNowLoading ||
                          isCriteriaButtonDisabled
                        "
                      >
                        <b-spinner small v-if="postItLaterLoading" />
                        <span v-else>{{ saveButtonTitle }}</span>
                      </b-button>
                    </div> -->
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      :visible="createJobModalVisible"
      hide-footer
      size="lg"
      @hidden="createJobModalVisible = false"
    >
      <div slot="modal-title" class="v2_color_black v2_font_weight_semibold">
        Your job offer has been created
      </div>
      <p>
        You can post your job opportunity to the Connect exchange now or save it
        to post later from Connect or your Dashboard. Your paid term of posting
        starts on the date of posting.
      </p>
      <div class="d-flex align-items-center justify-content-center">
        <b-button
          variant="v2_primary"
          @click="onPostJobOffer(1)"
          class="mr-4"
          :disabled="postItNowLoading || existMissingFields"
        >
          <b-spinner small v-if="postItNowLoading" />
          <span v-else>Post it now</span>
        </b-button>
        <b-button
          variant="v2_white"
          @click="onPostJobOffer(0)"
          :disabled="postItLaterLoading"
        >
          <b-spinner small v-if="postItLaterLoading" />
          <span v-else>Post it Later</span>
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import RecruiterJobOffersMatching from '@/components/recruiter/job_offers/RecruiterJobOffersMatching';
import { createLocationCriteria } from '@/helpers/recruiter/IcoBrowser/criteriaHelper';
import RecruiterIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaResults';
import JobOfferInput from '@/components/recruiter/exchange/create-job-offer/job-offer-input/JobOfferInput';
import {
  JOB_OFFER_CRITERIA,
  JOB_TERMS,
  JOB_OTHER_CRITERIA
} from '@/helpers/recruiter/jobOfferHelper';
//import JobOfferValues from '@/components/recruiter/exchange/create-job-offer/job-offer-values/JobOfferValues';
import RecruiterUserInfo from '@/components/recruiter/exchange/user-details/EditProfile';
import PurchasePage from '@/components/recruiter/payment/PurchasePage.vue';
import ReviewJobOffer from '@/components/recruiter/exchange/review/ReviewJobOffer';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';
import Help from '@/providers/Help';
import { COOKIES, JOB_QUESTION_TYPES } from '@/store';

const modifiedConfirmMessage =
  'The job offer has been modified but not saved yet. Would you like to continue and lose your changes?';

export default {
  name: 'RecruiterJobSummary',
  components: {
    RecruiterJobOffersMatching,
    RecruiterIcoCriteriaResults,
    JobOfferInput,
    RecruiterUserInfo,
    ReviewJobOffer,
    PurchasePage,
    HalfCircleSpinner,
  },
  data: function () {
    return {
      selectedJobQuestion: null,
      jobCriteria: JOB_OFFER_CRITERIA,
      jobTerms:[...JOB_OTHER_CRITERIA,...JOB_TERMS],
      loadingDetail: false,
      loadingJobTerms: false,
      postItLaterLoading: false,
      postItNowLoading: false,
      existMissingFields: false,
      createJobModalVisible: false,
      jobOffer: {},
      isJobOfferDirty: false,
      jobQuestions: [],
      numberOfMatches: 0,
      display_next:false,
      isShowStep:0,
      jDatas:[],
      job_terms_data:{},
      jobInfoText:false,
      LocationDisabled: true,
      practiceTypeFlag: true,
      maxCompFlag: true,
      isDisabled: true,
      isShowNextBtn:false,
      isShowLock:false,
      isSpecialtyShow:false
    };
  },
  created: async function () {
    if (this.$store.state.job_offer && this.$store.state.job_offer.length == 0) {
      this.jobTerms =  this.jobTerms.map(obj => {
        const { ...rest } = obj;
        return rest;
      });
    }
    this.jDatas = this.$store.state.job_offer;
    await this.getJobQuestions();
    if (this.$route.params.joId) {
      await this.getJobOfferData();
    } else {
      this.jobOffer.job_terms = {};
    }
    if (this.$store.state.job_offer == undefined || this.$store.state.job_offer.length == 0) {
      this.$store.state.job_offer = this.jobOfferCriteriaAndJobQuestions;
      this.$store.state.job_offer[0].value = {};
      this.$store.state.set_job_information = true;
    }
    this.isShowStep=1;

    if(this.$store.state.isComeFromIco)
    {
      this.isShowNextBtn=true;
      this.isShowLock = true;
      this.isSpecialtyShow=true;
    }
  },
  mounted() {
    this.selectedJobQuestion = (this.$store.state.isComeFromIco) ? this.jobTerms[0] : this.jobCriteria[0];
  },
  beforeMount: function () {
    window.addEventListener('beforeunload', this.preventEventIfDirtyOrErrors);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener(
        'beforeunload',
        this.preventEventIfDirtyOrErrors
      );
    });
    this.$root.$on('job-information-filled', (isJobInformationFilled) => {
      this.existMissingFields = !isJobInformationFilled;
      this.showSaveModal();
    });
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.postItLaterLoading || this.postItNowLoading) {
      window.location.reload();
      return next(false);
    }

    return this.isDirty()
      ? Help.confirm.show(
          modifiedConfirmMessage,
          'Leave',
          () => {
            next();
          },
          () => {
            next(false);
          }
        )
      : next();
  },
  computed: {
    saveButtonTitle: function () {
      return this.jobOffer.id ? 'Save Job Offer' : 'Create Job Offer';
    },
    isGmAdmin: function () {
      return this.$store.getters.userIsGMAdmin;
    },
    isMssRecruiter: function () {
      return this.$store.getters.userIsMSSRecruiter;
    },
    isCriteriaButtonDisabled: function () {
      return true;
      // return (
      //     (this.jobOffer || {}).status === JOB_OFFER_STATUSES.ACTIVE &&
      //     !this.isGmAdmin
      // );
    },
    jobOfferCriteriaAndJobQuestions: function () {
      return [...this.jobCriteria, ...this.jobQuestions, ...this.jobTerms];
      //return [...this.jobCriteria, ...this.jobTerms];
    },
    specialtyName: function () {
      return 'Specialty Title'
    },
    isEnableOpportunityBtn: function () {
    
      if(this.$store.state.isComeFromIco)
      {
        return true;
      }else{
        const specialtyCriteria = this.jobCriteria.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY
        );
      
        const locationCriteria = this.jobQuestions.find(
          (item) => item.type === JOB_QUESTION_TYPES.LOCATION
        );

        const practiceTypeCriteria = this.jobQuestions.find(
          (item) => item.type === JOB_QUESTION_TYPES.SELECT_ANY
        );

        const maxTotalCompansation = this.jobQuestions.find(
          (item) => item.type === JOB_QUESTION_TYPES.SLIDER
        );

        return (
          (specialtyCriteria &&
          specialtyCriteria.value &&
          specialtyCriteria.value.subspecialtyId) &&
          (locationCriteria &&
          locationCriteria.value) &&
          (practiceTypeCriteria &&
          practiceTypeCriteria.value) &&
          (maxTotalCompansation &&
          maxTotalCompansation.value)
        );
      }
    },
  },
  methods: {
    onSetCriteriaValue: function (params) {
      const index = this.jobCriteria.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.jobCriteria[index], 'value', params);
    },
    updateIsShowStep(newValue) {
      this.isShowStep = newValue;
    },
    updateJobOfferDetails: function (data) {
      const {
        title,
        description,
        tracking,
        jobBoardUrl,
        company,
        zipCode,
        welcome_message,
      } = data;
      this.$set(this.jobOffer, 'title', title);
      this.$set(this.jobOffer, 'description', description);
      this.$set(this.jobOffer, 'tracking_num', tracking);
      this.$set(this.jobOffer, 'external_url', jobBoardUrl);
      this.$set(this.jobOffer, 'company_name', company);
      this.$set(this.jobOffer, 'location_zip_code', zipCode);
      this.$set(this.jobOffer, 'welcome_message', welcome_message);
      this.isJobOfferDirty = true;
      this.isShowStep = 3; ///  For set Customer User Information update it 2.

      this.$store.state.job_information =  {
        ...this.$store.state.job_information,
        title: title,
        description: description,
        tracking_num: tracking,
        external_url: jobBoardUrl,
        company_name: company,
        //location_zip_code: zipCode,
        welcome_message: welcome_message,
      };

      const locIndex = this.$store.state.job_offer.findIndex(item => item.talent_type === 'LOCATION');
      this.$store.state.job_information.location_zip_code=this.$store.state.job_offer[locIndex].value.location_zip_code;

      //this.updateJobOffer();
    },
    updateSpecialty: function (data) {
      const { specialtyId, subspecialtyId } = data;
      this.$set(this.jobOffer, 'specialty_id', specialtyId);
      this.$set(this.jobOffer, 'subspecialty_id', subspecialtyId);
      this.isJobOfferDirty = true;

      //this.LocationDisabled = false;
      this.isDisabled = false;
      //this.selectedJobQuestion = this.jobQuestions[0];
      
      this.$store.state.is_new_offer = 1;
      
      this.$store.state.job_offer[0].value.specialtyId=specialtyId;
      this.$store.state.job_offer[0].value.subspecialtyId=subspecialtyId;
      this.jDatas = this.$store.state.job_offer;

      //this.selectedJobQuestion = this.jobCriteria[1];
      this.getNumberOfMatches();
      this.handleButtonClick(data.nextStep);
    },
    getJobOfferData: async function () {
      this.loadingDetail = true;
      try {
        // this.jobOffer = await Api.getJobOfferData(26);
        if (
          this.jobOffer.job_terms === null ||
          Array.isArray(this.jobOffer.job_terms)
        ) {
          this.$setgetJobOfferData(this.jobOffer, 'job_terms', {});
        }
        if (
          this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        ) {
          this.setResponsesFromCookies();
        } else {
          this.setJobQuestionResponses();
          this.setJobTermsResponses();
        }
        this.getNumberOfMatches();
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          this.$toasted.error('You are not allowed to view this job offer', {
            duration: 3000,
          });
          this.$router.push('/recruiter/exchange');
        } else handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingDetail = false;
      }
    },
    setJobQuestionResponses: function () {
      if (!this.jobQuestions || !this.jobOffer.jobQuestionResponses) return;
      Object.entries(this.jobOffer.jobQuestionResponses).forEach(
        ([id, value]) => {
          const index = this.jobQuestions.findIndex(
            (jq) => jq.id === parseInt(id)
          );
          if (index === -1) return;
          this.$set(this.jobQuestions[index], 'value', value);
        }
      );
      
    },
    setJobTermsResponses: function () {
      if (!this.jobTerms || !this.jobOffer.job_terms) return;
      Object.entries(this.jobOffer.job_terms).forEach(([type, value]) => {
        const index = this.jobTerms.findIndex((jt) => jt.type === type);
        if (index === -1) return;
        this.$set(this.jobTerms[index], 'value', []);
        this.$set(this.jobTerms[index].value, 0, value);
      });
    },
    setResponsesFromCookies: function () {
      const values = JSON.parse(
        this.$cookies.get(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
      );
      values.forEach(({ id, type, value }) => {
        if (!value) return;

        if (type === JOB_QUESTION_TYPES.SPECIALTY) {
          const index = this.jobCriteria.findIndex(
            (i) => i.type === JOB_QUESTION_TYPES.SPECIALTY
          );
          if (index === -1) return;
          this.$set(this.jobCriteria[index], 'value', { ...value });
          this.$set(this.jobOffer, 'specialty_id', value.specialtyId);
          this.$set(this.jobOffer, 'subspecialty_id', value.subspecialtyId);
          return;
        }

        if (type === JOB_QUESTION_TYPES.LOCATION) {
          const index = this.jobCriteria.findIndex(
            (i) => i.type === JOB_QUESTION_TYPES.JOB_INFORMATION
          );
          if (index === -1) return;
          this.$set(this.jobCriteria[index], 'value', { ...value });
          this.$set(
            this.jobOffer,
            'location_zip_code',
            value.location_zip_code
          );
          return;
        }

        const index = this.jobQuestions.findIndex((jQ) => {
          return jQ.id === id;
        });
        if (index === -1) return;
        this.$set(this.jobQuestions[index], 'value', { ...value });
      });
    },
    onPostJobOffer: async function (postItNow = 0) {
      if (this.jobOffer.id) {
        await this.saveJobPostOffer(postItNow);
      } else {
        await this.createJobOffer(postItNow);
      }
      if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
        this.$cookies.remove(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES);
      }
    },
    createJobOffer: async function (postItNow = 0) {
      const loadingVarName = postItNow
        ? 'postItNowLoading'
        : 'postItLaterLoading';
      this[loadingVarName] = true;
      try {
        const jobOffer = {
          ...this.jobOffer,
          jobQuestions: this.jobQuestions,
        };

        await Api.createJobOfferData(jobOffer, postItNow);
        this.resetValidation();
        this[loadingVarName] = false;
        this.$router.push('/recruiter/exchange');
        this.$toasted.success('Job Offer created successfully', {
          duration: 3000,
        });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this[loadingVarName] = false;
        this.createJobModalVisible = false;
      }
    },
    saveJobPostOffer: async function (postItNow = 0) {
      const loadingVarName = postItNow
        ? 'postItNowLoading'
        : 'postItLaterLoading';
      this[loadingVarName] = true;

      try {
        await this.updateJobOffer(postItNow);
        this.resetValidation();
        this[loadingVarName] = false;
        this.$toasted.success('Job Offer updated successfully', {
          duration: 3000,
        });
        if (this.isGmAdmin) {
          this.$router.push('/admin/job-offers');
        } else {
          this.$router.push('/recruiter/exchange');
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this[loadingVarName] = false;
        this.createJobModalVisible = false;
      }
    },
    updateJobOffer: async function (postItNow = 0) {
      const jobOffer = {
        ...this.jobOffer,
        jobQuestions: this.jobQuestions,
      };

      try {
        if (this.isGmAdmin) {
          await Api.updateJobOfferDataByGmAdmin(jobOffer, postItNow);
        } else {
          await Api.updateJobOfferData(jobOffer, postItNow);
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        await this.getNumberOfMatches();
      }
    },
    getNumberOfMatches: async function () {
      // this.numberOfMatches = await Api.getNumberOfJobOfferMatches(
      //   this.jobOffer.id
      // );
      this.loadingMatching = true;
      try {
        this.numberOfMatches = (this.$store.state.user) ? await Api.findNumberOfMatches(this.jDatas) : await Api.findNumberOfMatchesOnGuestIcoBrowser(this.jobOfferCriteriaAndJobQuestions);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingMatching = false;
      }
    },
    onSave: function () {
      if (this.isGmAdmin) return this.saveJobPostOffer();
      this.$root.$emit('check-job-information-filled');
    },
    showSaveModal: function () {
      this.createJobModalVisible = true;
    },
    isDirty: function () {
      return (
        this.isJobOfferDirty ||
        (this.$refs.jobOfferInput &&
          typeof this.$refs.jobOfferInput.isDirty === 'function' &&
          this.$refs.jobOfferInput.isDirty())
      );
    },
    hasErrors: function () {
      return this.$refs.jobOfferInput &&
        typeof this.$refs.jobOfferInput.hasErrors === 'function'
        ? this.$refs.jobOfferInput.hasErrors()
        : false;
    },
    resetValidation: function () {
      this.isJobOfferDirty = false;
      return (
        this.$refs.jobOfferInput &&
        typeof this.$refs.jobOfferInput.resetValidation === 'function' &&
        this.$refs.jobOfferInput.resetValidation()
      );
    },
    preventEventIfDirtyOrErrors: function (event) {
      if (!this.postItLaterLoading && !this.isDirty() && !this.hasErrors())
        return;
      event.preventDefault();
      event.returnValue = '';
    },
    getJobQuestions: async function () {
      const additionalCriteria = createLocationCriteria();
      this.loadingJobTerms = true;
      try {
        // this.jobQuestions = await Api.getJobQuestionsForJobOffer();
        this.jobQuestions = await Api.getJobQuestionsForGuestIcoBrowser();
        this.jobQuestions = [additionalCriteria, ...this.jobQuestions];
        
        this.setJobQuestionResponses();
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingJobTerms = false;
        await this.getNumberOfMatches();
      }
    },
    onSetJobQuestionValue: function (params) {  
      if(params.location_zip_code)
      {
        const locIndex = this.$store.state.job_offer.findIndex(item => item.talent_type === 'LOCATION');
        this.$set(this.$store.state.job_offer[locIndex], 'value', { ...params });
        this.$store.state.location_zip_code = params.location_zip_code;
        this.isDisabled = false;
        //this.practiceTypeFlag=false;
        //this.selectedJobQuestion = this.jobQuestions[1];
        
        //this.$store.state.job_offer[locIndex].value = params.location_zip_code;
        //this.$store.state.job_information.location_zip_code=params.location_zip_code;
        // this.$store.state.job_offer[0].value.location_zip_code=params.location_zip_code;
        this.handleButtonClick(params.nextStep);
      }else{
        const index = this.jobQuestions.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
        });
        
        this.$set(this.jobQuestions[index], 'value', {
          ...params,
        });

        const JobId = this.jobQuestions[index].id;
        const jData = this.$store.state.job_offer;
        var index2 = -1;
        jData.find(function(item, i){
          if(item.id === JobId){
            index2 = i;
            return i;
          }
        });
        this.$store.state.job_offer[index2].value=params;

        // this.maxCompFlag = false;
        // this.selectedJobQuestion = this.jobQuestions[2];

        this.isDisabled = false;
        //this.isCriteriaButtonDisabled = false;
        this.handleButtonClick(params.nextStep,index);
      }
      this.jDatas = this.$store.state.job_offer;     

      
      this.getNumberOfMatches();
      //this.handleButtonClick(params.nextStep);
      
    },
    getSessionData: function(data){
      this.jDatas = data;
    },
    onSetJobTerms: function (params) {
      const index = this.jobTerms.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.jobTerms[index], 'value', {
        ...params,
      });
      this.$set(
        this.jobOffer.job_terms,
        this.jobTerms[index].type,
        { ...params }[0]
      );
      //this.updateJobOffer();
      this.getNumberOfMatches();
    },
    onSetProfileJobTerms: function (params) {
      const index = this.jobTerms.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });

      if (!params || !Object.keys(params).length) {
        this.$delete(this.jobTerms[index], 'value');
        this.$delete(this.jobOffer.job_terms, this.jobTerms[index].type);
        return;
      }

      let key = Object.keys(params)[0];

      this.$set(
        this.jobTerms[index],
        'value',
        key
          ? {
              0: key,
            }
          : {}
      );

      this.$set(
        this.jobOffer.job_terms,
        this.jobTerms[index].type,
        key || null
      );

      //this.updateJobOffer();
    },
    showLockIcon: function (criteria) {
      return (
        !!(
          this.jobOffer &&
          this.jobOffer.specialty_id
        ) && criteria.type === JOB_QUESTION_TYPES.SPECIALTY
      );
    },
    showLockIconOnQuestion: function (jobQuestion) {
      if(jobQuestion.talent_type == 'LOCATION')
      {
        if(this.$store.state.location_zip_code)
        {
          return true;
        }else{
          return false;
        }
      }else{
        return (
          !!jobQuestion.value 
        );
      }
    },
    showLockIconOnTerm: function (jobTerm) {
      return (
        !!jobTerm.value
      );
    },
    showNextButton: function () {
    this.display_next = true;
    },
    handleButtonClick(nextStep,index=0) {
      if(!this.$store.state.isComeFromIco)
      {
        if(nextStep === 'LOCATION'){
        this.LocationDisabled = false;
        this.selectedJobQuestion = this.jobQuestions[0];
        this.isShowNextBtn=false;
        }else if(nextStep === 'PRTYPE')
        {
          this.practiceTypeFlag = false;
          this.selectedJobQuestion = this.jobQuestions[1];
          this.isShowNextBtn=false;
        }else 
        {
            this.maxCompFlag = false;
            this.selectedJobQuestion = this.jobQuestions[2];
            this.isShowNextBtn=false;
        }
        if(index==2)
        {
          this.isShowNextBtn=true;
        }
        // if(this.LocationDisabled == false && this.practiceTypeFlag == false && this.maxCompFlag==true)
        // {
        //   this.maxCompFlag = false;
        //   this.selectedJobQuestion = this.jobQuestions[2];
        //   this.isShowNextBtn=true;
        // }else if(this.LocationDisabled == false && this.practiceTypeFlag == true)
        // {
        //   this.practiceTypeFlag = false;
        //   this.selectedJobQuestion = this.jobQuestions[1];
        // }else if(this.LocationDisabled == true)
        // {
        //   this.LocationDisabled = false;
        //   this.selectedJobQuestion = this.jobQuestions[0];
        // }
        // this.isDisabled = true;
      }
      
      // Perform actions based on the button's label
      // if (label === 'Next') {
      //   this.isShowStep=2;
      //   //this.$router.push("/recruiter/profile");
      // } 
    },
    saveJobOffer: async function(jdata) {
      
      // try {
      //   const keyMapping = {
      //   "title": "title",
      //   "description": "description", // Here, the typo in the key is retained as "descriotn" as per your requirement.
      //   "tracking": "tracking_num", // Renaming "tracking" to "tracking_nume"
      //   "jobBoardUrl": "external_url", // Renaming "jobBoardUrl" to "external_url"
      //   "company": "company_name", // Renaming "company" to "company_name"
      //   //"zipCode": "location_zip_code", // Renaming "zipCode" to "job_location_pincode"
      //   "welcome_message": "welcome_message" // Retaining the same key "welcome_message"
      // };

      // function transformAndMergeData(jobInformation, jobOffer) {
      //   // Transform jobInformation data using the key mapping
      //   const transformedData = Object.fromEntries(
      //     Object.entries(jobInformation).map(([oldKey, value]) => [keyMapping[oldKey] || oldKey, value])
      //   );
      //   const firstElementValue = jobOffer[0].value;
      //   const modifiedFirstElementValue = {
      //   ...firstElementValue,
      //     subspecialty_id: firstElementValue.subspecialtyId,
      //     specialty_id: firstElementValue.specialtyId
      //   };
      //   // Merge the first element's "value" key from jobOffer with transformedData
        
      //   //const mergedData = { ...transformedData, ...firstElementValue };
      //   const mergedData = { ...transformedData, ...modifiedFirstElementValue };

      //   // Extract the last two objects from jobOffer and set them in jobQuestions key
      //   // if(localStorage.getItem('job_offer_signup_data'))
      //   // {
      //   //   mergedData.jobQuestions = jobOffer.slice(-2);
      //   // }else{
      //   //   mergedData.jobQuestions = jobOffer.slice(-4);
      //   // }
      //   //console.log(JSON.stringify(jobOffer));
      //   //mergedData.jobQuestions = jobOffer.slice(-2);
        
      //   /// Get tob terms //////
      //   // const boardCertification = jobOffer.filter(item => item.type === "BOARD_CERTIFICATION");
      //   // const boardCertificationValue = (boardCertification[0].value[0]) ? boardCertification[0].value[0] : null;
      //   // if(boardCertificationValue !== null)
      //   // {
      //   //   // const jobTermsValues = {
      //   //   //   BOARD_CERTIFICATION: boardCertificationValue,
      //   //   //   VISA_STATUS: 'PERM'
      //   //   // };
      //   //   // this.jTerms = jobTermsValues;
      //   // }
        
      //   //mergedData.jobQuestions = jobOffer.filter(item => item.type !== "JOB_INFORMATION" && item.type !== "LOCATION" && item.type !== 'SPECIALTY' && item.type !== 'BOARD_CERTIFICATION' && item.type !== 'VISA_STATUS');
      //   mergedData.jobQuestions = jobOffer.filter(item => item.type !== "JOB_INFORMATION" && item.type !== "LOCATION" && item.type !== 'SPECIALTY');

      //   //console.log(JSON.stringify(mergedData));
      //   return mergedData;
      // }

      // // Usage
      // const jobInformation = this.$store.state.job_information;
      // const jobOffer = this.$store.state.job_offer;

      // const data = transformAndMergeData(jobInformation, jobOffer);
      //   await Api.createJobOfferData(data, 0);
      //   // this.resetValidation();
      //   // this[loadingVarName] = false;
        
      //   this.$store.state.job_offer = [];
      //   this.$store.state.job_information = [];
      //   this.$store.state.show_payment_page = '';
      //   this.$store.state.is_new_offer = null;
      //   this.$store.state.location_zip_code = null;
        
      //   localStorage.removeItem('job_offer_signup_data');
        
      //   this.$toasted.success('Job Offer created successfully', {
      //     duration: 3000,
      //   });
        this.$store.state.isComeFromIco = null;
        if(jdata == 'dashboard'){
          this.$router.push('/recruiter');
        }else if(jdata == 'inform'){
          this.$router.push('/recruiter/inform');
        }
      // } catch (error) {
      //   handleServerErrorWithValidation(error, this.$toasted);
      // } finally {
      //   // this[loadingVarName] = false;
      //   // this.createJobModalVisible = false;
      // }
    },
    goToJobInfo: function (){
      const index = this.jobCriteria.findIndex((jt) => jt.type === "JOB_INFORMATION");
      if (index === -1)  this.selectedJobQuestion = this.jobCriteria[index]; else  this.selectedJobQuestion = this.jobCriteria[index];
    },
    showJobInfo: function(data){
      this.jobInfoText=data;
    },
  },
};
</script>

<style scoped>
.post_opportunity_btn{
  display: flex;
  align-items: center;
  flex-flow: column;
  height: unset;
}
.post_opportunity_btn p {
  line-height: 18px;
  margin-bottom: 0;
  padding-top: 20px;
}
.center-align-box{
  align-content: center;
  height: 100%;
}

.margin-0-auto{
  margin: 0 auto;
}
.btn-disable-btn{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  border-color: #00586f !important;
  opacity: 1;
}
.btn-disable-btn:disabled{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #dee9ec !important;
  border: 1px solid #00586f !important;
  border-color: #00586f !important;
  opacity: 1;
}
.btn-disable-btn i{
  font-size: 15px;
}
.btn.btn-primary.disabled{
  border-color: #00586f !important;
}
btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  border-radius: 20px;
}
.btn-next i{
  font-size:15px;
}
.position-relative{
  position: relative;
}
.connect-opp-btn-main-div{
  position: relative;
  display: flex;
  width: 100%;
  flex-flow: column;
  justify-content: space-between;
}
.connect-opp-btn{
  position:absolute;bottom: 40px;
}
</style>

